import apiRequestService from '@/commonProject/service/apiRequestService';

export default class HomeRepository {
    /**
     * メニュー情報取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getMenuApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/mnudtl', requestBody, idToken);
        return result;
    }

    /**
     * 新着情報確認API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getNewArrivalApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/arvchk', requestBody, idToken);
        return result;
    }
}
